import { render } from "./LoginForm.vue?vue&type=template&id=79b1dae9"
import script from "./LoginForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./LoginForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script